import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ServiceProvider } from '../../../providers/ServiceProvider';
import { AppDescribtionPage } from '../../AppDescribtion/AppDescribtion';

/*
  Generated class for the TeachingResources page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-TeachingResources',
    templateUrl: 'TeachingResources.html'
})
export class TeachingResourcesPage {

    constructor(public navCtrl: NavController, public navParams: NavParams, public serviceProvider: ServiceProvider) { }
    TResources: any = [];
    ionViewDidLoad() {
        this.TResources.splice(0, this.TResources.length);
        this.serviceProvider.Get('ISPA_acTrainingList', false).then((result) => {
            let resources: any = result;
            resources.forEach((value, index) => {
                this.TResources.push(value);
            });
        });
    }

    ShowContent(res) {
        this.navCtrl.push(AppDescribtionPage, { Title: res.cdValue1_txt, Color: "yellow", Text: "", DataToShow: res.cdValue2_txt });
    }

}



// WEBPACK FOOTER //
// ./src/pages/academy/TeachingResources/TeachingResources.ts